import moment from 'moment';
import { TenantFields } from '../../fields/FieldTypes';
import { getCollectionFieldTraitOptions, getCollectionFields } from '../pluginComponentApi';
import {
  NoRefFields,
  hiddenFormField,
  ImageUrlFields,
  AllSelectOptionFields,
  FieldTypes,
  dataSourcePrimaryKeys,
  URLFields,
  passwordField,
} from 'drapcode-constant';
const { reference, file, boolean, text, number, uuid, createdBy, updatedBy, version } = FieldTypes;
export const getFieldsTraits = async (
  componentType,
  collectionName,
  collections,
  allowedTenantField = false,
) => {
  let collectionResponse = await getCollectionFields(collectionName, collections);
  if (!collectionResponse) {
    return {
      type: 'input-field',
      label: 'Collection Field ',
      name: 'collectionField',
      changeProp: 1,
      options: [{ id: '', name: 'None' }],
    };
  }
  let options = [];
  let nestedFields = [];
  const referenceFields = collectionResponse.fields.filter(
    (field) => field.type === reference.id && field.refCollection.displayType === 'innerForm',
  );
  if (referenceFields.length > 0) {
    await Promise.all(
      referenceFields.map(async (field) => {
        const collectionRes = await getCollectionFields(
          field.refCollection.collectionName,
          collections,
        );
        const refFields = collectionRes.fields.map((nestedField) => {
          const copyField = Object.assign({}, nestedField);
          copyField.fieldName = field.fieldName + '.' + nestedField.fieldName;
          copyField.fieldTitle.en = field.fieldTitle.en + '---->' + nestedField.fieldTitle.en;
          return copyField;
        });
        nestedFields = [...nestedFields, ...refFields];
      }),
    );
  }
  const fields = [...collectionResponse.fields, ...nestedFields];
  switch (componentType) {
    case 'input':
      options = await getFieldsTraitsForInputControl(fields);
      break;
    case 'file-input':
      options = await getFieldsTraitsForFileControl(fields);
      break;
    case 'select':
    case 'radio':
      options = await getFieldsTraitsForSelectControl(fields);
      break;
    case 'checkbox':
      options = await getFieldsTraitsForBooleanControl(fields);
      break;
    case 'collection-field':
      options = await getFieldsTraitsCollectionField(fields, allowedTenantField);
      options = [{ id: '', name: 'None' }, ...options];
      return {
        type: 'select',
        label: 'Collection Field ',
        name: 'collectionFormField',
        changeProp: 1,
        options: options,
      };
    case 'collection-file-dropzone':
      options = await getFieldsTraitsOptionsForFileDropzone(fields);
      options = [{ id: '', name: 'None' }, ...options];
      return {
        type: 'select',
        label: 'Collection Field ',
        name: 'collectionFormFileDropzone',
        changeProp: 1,
        options: options,
      };
    case 'collection-file-dropzone-get-content-from-collection':
      options = await getFieldsTraitsOptionsForFileDropzone(fields, true);
      options = [{ id: '', name: 'None' }, ...options];
      return {
        type: 'select',
        label: 'Collection Field ',
        name: 'formCollectionField',
        changeProp: 1,
        options: options,
      };
  }
  options = [{ id: '', name: 'None' }, ...options];
  return {
    type: 'input-field',
    label: 'Collection Field ',
    name: 'collectionField',
    changeProp: 1,
    options: options,
  };
};

export const getSelectLabelFields = async (collectionName, collections, collectionFieldName) => {
  let options = [{ id: '', name: 'None' }];
  let collectionResponse = await getCollectionFields(collectionName, collections);
  const collectionField = collectionResponse
    ? collectionResponse.fields.find((field) => field.fieldName === collectionFieldName)
    : '';
  if (collectionField && collectionField.type === reference.id) {
    const refCollectionName = collectionField.refCollection.collectionName;
    let refCollection = await getCollectionFields(refCollectionName, collections);
    let nestedFields = [];
    const referenceFields = refCollection
      ? refCollection.fields.filter((field) => field.type === reference.id)
      : [];
    if (referenceFields.length > 0) {
      await Promise.all(
        referenceFields.map(async (field) => {
          const collectionRes = await getCollectionFields(
            field.refCollection.collectionName,
            collections,
          );
          const refFields = collectionRes
            ? collectionRes.fields.map((nestedField) => {
                const copyField = _.cloneDeep(nestedField);
                copyField.fieldName = field.fieldName + '.' + nestedField.fieldName;
                copyField.fieldTitle.en = field.fieldTitle.en + '---->' + nestedField.fieldTitle.en;
                return copyField;
              })
            : [];
          nestedFields = [...nestedFields, ...refFields];
        }),
      );
    }
    const refFields = refCollection
      ? refCollection.fields
          .filter((field) => field.type !== reference.id)
          .map((field) => ({ ...field, optionType: 'fields' }))
      : [];
    nestedFields = nestedFields.map((field) => ({ ...field, optionType: 'reference_field' }));
    const fields = [...refFields, ...nestedFields];
    options = await getFieldsTraitsCollectionField(fields);
    const derivedFields = refCollection
      ? refCollection.utilities.map((field) => ({
          ...field,
          optionType: 'derived_fields',
        }))
      : [];
    const derivedFieldsOptions = getFieldsTraitsDerivedField(derivedFields);
    options = [{ id: '', name: 'None', optionType: 'fields' }, ...options, ...derivedFieldsOptions];
    return {
      type: 'dropdown-label-field',
      label: 'Dropdown Label Field',
      name: 'dropdownLabel',
      changeProp: 1,
      options,
    };
  }
};

export const getCurrentUserFieldsTraits = async (componentType, collectionName, collections) => {
  let collectionResponse = await getCollectionFields(collectionName, collections);
  if (!collectionResponse) {
    return {
      type: 'select-current-user-field',
      label: 'User Collection Field ',
      name: 'currentUserCollectionField',
      changeProp: 1,
      options: [{ id: '', name: 'None' }],
    };
  }
  let options = [];
  const fields = [...collectionResponse.fields];
  switch (componentType) {
    case 'select':
      options = await getFieldsTraitsForCollectionSelectControl(
        fields,
        collections,
        'user',
        'CURRENT_USER',
      );
      break;
    case 'collection-file-dropzone':
      options = await getFieldsTraitsOptionsForFileDropzone(fields, true);
      options = [{ id: '', name: 'None' }, ...options];
      return {
        type: 'select',
        label: 'User Collection Field ',
        name: 'currentUserCollectionField',
        changeProp: 1,
        options: options,
      };
  }
  options = [{ id: '', name: 'None' }, ...options];
  return {
    type: 'select-current-user-field',
    label: 'User Collection Field ',
    name: 'currentUserCollectionField',
    changeProp: 1,
    options: options,
  };
};

export const getCurrentTenantFieldsTraits = async (
  componentType,
  collectionName,
  collections,
  multiTenantCollectionUuid,
) => {
  let collectionResponse = await getCollectionFields(collectionName, collections);
  if (!collectionResponse) {
    return {
      type: 'select-current-tenant-field',
      label: 'User Tenant Field ',
      name: 'currentTenantCollectionField',
      changeProp: 1,
      options: [{ id: '', name: 'None' }],
    };
  }
  let options = [];
  const fields = [...collectionResponse.fields];
  switch (componentType) {
    case 'select':
      const multiTenantCollection = collections.find(
        (collection) => collection.uuid === multiTenantCollectionUuid,
      );
      const collectionName = multiTenantCollection ? multiTenantCollection.collectionName : '';
      options = await getFieldsTraitsForCollectionSelectControl(
        fields,
        collections,
        collectionName,
        'CURRENT_TENANT',
      );
      break;
    case 'collection-file-dropzone':
      options = await getFieldsTraitsOptionsForFileDropzone(fields, true);
      options = [{ id: '', name: 'None' }, ...options];
      return {
        type: 'select',
        label: 'User Tenant Field ',
        name: 'currentTenantCollectionField',
        changeProp: 1,
        options: options,
      };
  }
  options = [{ id: '', name: 'None' }, ...options];
  return {
    type: 'select-current-tenant-field',
    label: 'User Tenant Field ',
    name: 'currentTenantCollectionField',
    changeProp: 1,
    options: options,
  };
};

export const getCurrentUserSettingsFieldsTraits = async (
  componentType,
  collectionName,
  collections,
  userSettingsCollectionUuid,
) => {
  let collectionResponse = await getCollectionFields(collectionName, collections);
  if (!collectionResponse) {
    return {
      type: 'select-current-user-settings-field',
      label: 'User Settings Field ',
      name: 'currentUserSettingsCollectionField',
      changeProp: 1,
      options: [{ id: '', name: 'None' }],
    };
  }
  let options = [];
  const fields = [...collectionResponse.fields];
  switch (componentType) {
    case 'select':
      const userSettingsCollection = collections.find(
        (collection) => collection.uuid === userSettingsCollectionUuid,
      );
      const collectionName = userSettingsCollection ? userSettingsCollection.collectionName : '';
      options = await getFieldsTraitsForCollectionSelectControl(
        fields,
        collections,
        collectionName,
        'CURRENT_USER_SETTING',
      );
      break;
    case 'collection-file-dropzone':
      options = await getFieldsTraitsOptionsForFileDropzone(fields, true);
      options = [{ id: '', name: 'None' }, ...options];
      return {
        type: 'select',
        label: 'User Settings Field ',
        name: 'currentUserSettingsCollectionField',
        changeProp: 1,
        options: options,
      };
  }
  options = [{ id: '', name: 'None' }, ...options];
  return {
    type: 'select-current-user-settings-field',
    label: 'User Settings Field ',
    name: 'currentUserSettingsCollectionField',
    changeProp: 1,
    options: options,
  };
};

export const getCurrentSubTenantFieldsTraits = async (
  componentType,
  collectionName,
  collections,
  subTenantCollectionUuid,
) => {
  let collectionResponse = await getCollectionFields(collectionName, collections);
  if (!collectionResponse) {
    return {
      type: 'select-current-sub-tenant-field',
      label: 'User Sub Tenant Field ',
      name: 'currentSubTenantCollectionField',
      changeProp: 1,
      options: [{ id: '', name: 'None' }],
    };
  }
  let options = [];
  const fields = [...collectionResponse.fields];
  switch (componentType) {
    case 'select':
      const subTenantCollection = collections.find(
        (collection) => collection.uuid === subTenantCollectionUuid,
      );
      const collectionName = subTenantCollection ? subTenantCollection.collectionName : '';
      options = await getFieldsTraitsForCollectionSelectControl(
        fields,
        collections,
        collectionName,
        'CURRENT_SUB_TENANT',
      );
      break;
    case 'collection-file-dropzone':
      options = await getFieldsTraitsOptionsForFileDropzone(fields, true);
      options = [{ id: '', name: 'None' }, ...options];
      return {
        type: 'select',
        label: 'User Sub Tenant Field ',
        name: 'currentSubTenantCollectionField',
        changeProp: 1,
        options: options,
      };
  }
  options = [{ id: '', name: 'None' }, ...options];
  return {
    type: 'select-current-sub-tenant-field',
    label: 'User Sub Tenant Field ',
    name: 'currentSubTenantCollectionField',
    changeProp: 1,
    options: options,
  };
};

const getFieldsTraitsForSelectControl = async (fields) => {
  const collectionFields = fields.filter((field) => AllSelectOptionFields.includes(field.type));
  return collectionFields.map((item) => {
    return { id: JSON.stringify(item), name: item.fieldTitle.en };
  });
};

const getFieldsTraitsForCollectionSelectControl = async (
  fields,
  collections,
  collectionName,
  copyFieldFrom,
) => {
  let collectionDetails = {};
  let currentUserFields = [];
  let fieldRefCollectionNames = [];
  const collectionFields = fields.filter((field) => AllSelectOptionFields.includes(field.type));
  if (collectionFields && collectionFields.length > 0) {
    collectionFields.forEach((colField) => {
      const { refCollection } = colField;
      const { collectionName } = refCollection ? refCollection : '';
      fieldRefCollectionNames.push(collectionName);
    });
  }
  let collection = collectionDetails[collectionName];
  if (!collection) {
    try {
      const collectionFieldResponse = await getCollectionFields(collectionName, collections);
      if (collectionFieldResponse) {
        collection = collectionFieldResponse;
      }
      collectionDetails[collectionName] = collection;
    } catch (error) {
      console.error('*** User collection not found. ', error.message);
      collection = '';
    }
  }

  const currentRefFields = collection
    ? collection.fields.filter((field) => AllSelectOptionFields.includes(field.type))
    : '';
  if (currentRefFields && currentRefFields.length > 0) {
    currentUserFields = currentRefFields
      .filter((field) => fieldRefCollectionNames.includes(field.refCollection.collectionName))
      .map((field) => {
        const refCollName = field.refCollection.collectionName;
        let collectionRefField = refCollName
          ? collectionFields.find(
              (collectionField) =>
                collectionField.refCollection.collectionName === refCollName.trim(),
            )
          : '';

        const copyField = _.cloneDeep(field);
        copyField.meta = {
          from: copyFieldFrom,
          orgFieldName: collectionRefField ? collectionRefField.fieldName : field.fieldName,
          fieldName: field.fieldName,
          fieldTitle: {
            en: collectionRefField ? collectionRefField.fieldTitle.en : field.fieldTitle.en,
          },
          isMultiSelect: collectionRefField
            ? collectionRefField.isMultiSelect
            : field.isMultiSelect,
        };

        copyField.fieldName = `${field.fieldName}`;
        return copyField;
      });

    const currentUserRefFields = currentRefFields.filter((field) => reference.id === field.type);
    if (currentUserRefFields && currentUserRefFields.length > 0) {
      await Promise.all(
        currentUserRefFields.map(async (field) => {
          const refCollName = field.refCollection.collectionName;
          let collectionRes = collectionDetails[refCollName];
          if (!collectionRes) {
            collectionRes = await getCollectionFields(refCollName, collections);
            collectionDetails[refCollName] = collectionRes;
          }

          const currentNestedRefFields = collectionRes
            ? collectionRes.fields
                .filter(
                  (field) =>
                    AllSelectOptionFields.includes(field.type) &&
                    fieldRefCollectionNames.includes(field.refCollection.collectionName),
                )
                .map((nestedField) => {
                  const copyField = _.cloneDeep(nestedField);
                  copyField.meta = {
                    from: copyFieldFrom,
                    orgFieldName: nestedField.fieldName,
                    fieldName: `${field.fieldName}.${nestedField.fieldName}`,
                    fieldTitle: { en: nestedField.fieldTitle.en },
                    isMultiSelect: field.isMultiSelect,
                  };

                  // copyField.fieldName = `${
                  //   field.fieldName.startsWith('CURRENT_USER') ? '' : 'CURRENT_USER.'
                  // }${field.fieldName}.${nestedField.fieldName}`;
                  // copyField.fieldTitle.en = `${
                  //   field.fieldTitle.en.startsWith('Current Logged In User')
                  //     ? ''
                  //     : 'Current Logged In User:'
                  // } ${field.fieldTitle.en} -> ${nestedField.fieldTitle.en}`;
                  copyField.fieldName = `${field.fieldName}.${nestedField.fieldName}`;
                  copyField.fieldTitle.en = `${field.fieldTitle.en} -> ${nestedField.fieldTitle.en}`;
                  return copyField;
                })
            : [];
          currentUserFields = [...currentUserFields, ...currentNestedRefFields];
        }),
      );
    }
  }

  let collectionFieldsIncludingNested = [...currentUserFields];
  return collectionFieldsIncludingNested.map((item) => {
    return { id: JSON.stringify(item), name: item.fieldTitle.en };
  });
};

const getFieldsTraitsForFileControl = async (fields) => {
  return fields
    .filter((field) => ImageUrlFields.includes(field.type) || field.type === 'reference')
    .map((item) => {
      return { id: JSON.stringify(item), name: item.fieldTitle.en };
    });
};

const getFieldsTraitsForBooleanControl = async (fields) => {
  return fields
    .filter((field) => field.type === boolean.id)
    .map((item) => {
      return { id: JSON.stringify(item), name: item.fieldTitle.en };
    });
};

const getFieldsTraitsForInputControl = async (fields) => {
  return fields
    .filter((field) => [...passwordField, number.id, uuid.id].includes(field.type))
    .map((item) => {
      return { id: JSON.stringify(item), name: item.fieldTitle.en };
    });
};

const getFieldsTraitsCollectionField = async (fields, allowedTenantField = false) => {
  let finalFields = [];
  finalFields = fields.filter(
    (field) =>
      !hiddenFormField.includes(field.type) && !dataSourcePrimaryKeys.includes(field.fieldName),
  );
  if (!allowedTenantField) {
    finalFields = finalFields.filter((field) => !TenantFields.includes(field.fieldName));
  }
  return finalFields.map((item) => {
    return {
      id: JSON.stringify(item),
      name: item.fieldTitle.en,
      optionType: item.optionType ? item.optionType : '',
    };
  });
};

const getFieldsTraitsDerivedField = (derivedFields) => {
  return (
    derivedFields &&
    derivedFields.map((item) => {
      return { id: JSON.stringify(item), name: item.name, optionType: item.optionType };
    })
  );
};

const getFieldsTraitsOptionsForFileDropzone = async (fields, isGetContent = false) => {
  return fields
    .filter(
      (field) =>
        !hiddenFormField.includes(field.type) &&
        !dataSourcePrimaryKeys.includes(field.fieldName) &&
        !TenantFields.includes(field.fieldName) &&
        [...URLFields, reference.id].includes(field.type),
    )
    .map((item) => {
      return isGetContent
        ? { id: item.fieldName, name: item.fieldTitle.en }
        : { id: JSON.stringify(item), name: item.fieldTitle.en };
    });
};

export const getFieldsTraitsOptionsForAutocomplete = (fields) => {
  return fields
    .filter((field) => NoRefFields.includes(field.type))
    .map((field) => ({ value: field.fieldName, name: field.fieldTitle.en }));
};

export const getDataItemIdFieldsTraits = async (
  traitName,
  componentType,
  selectedCollectionName,
  collections,
  multiTenantCollectionUuid,
) => {
  let collectionName = selectedCollectionName;
  if (multiTenantCollectionUuid) {
    const multiTenantCollection = collections.find(
      (collection) => collection.uuid === multiTenantCollectionUuid,
    );
    collectionName = multiTenantCollection ? multiTenantCollection.collectionName : '';
  }

  let collectionResponse = await getCollectionFields(collectionName, collections);
  if (!collectionResponse) {
    return {
      type: 'select',
      label: 'Collection Field ',
      name: traitName,
      // changeProp: 1,
      options: [{ id: '', name: '- Select One -' }],
    };
  }
  let options = [];
  switch (componentType) {
    case 'input':
      options = await getCollectionFieldTraitOptions(collectionResponse, collections);
      options = options.filter(
        (field) =>
          !field.type ||
          [text.id, uuid.id, reference.id, createdBy.id, updatedBy.id, version.id].includes(
            field.type,
          ),
      );
      break;
  }
  options = [{ id: '', name: '- Select One -' }, ...options];
  return {
    type: 'select',
    label: 'Collection Field ',
    name: traitName,
    // changeProp: 1,
    options: options,
  };
};

export const settingDates = [
  'MM/DD/YY',
  'MM-DD-YY',
  'MM/DD/YYYY',
  'MM-DD-YYYY',
  'DD-MM-YY',
  'DD/MM/YY',
  'DD-MM-YYYY',
  'DD/MM/YYYY',
  'YYYY-MM-DD',
  'YYYY/MM/DD',
  'YYYY-DD-MM',
  'YYYY/DD/MM',
];

export const lableForDatePatters = (pattern) => {
  if (pattern) {
    switch (pattern) {
      case 'FROM_NOW':
        return `Time till now (i.e.: ${moment().fromNow()} , 3 days ago etc..)`;
      case 'X':
        return `X (Timestamp in Sec) (i.e.: ${moment().format('X')})`;
      case 'x':
        return `x (Timestamp in Millisec) (i.e.: ${moment().format('x')})`;
      default:
        return `${pattern} (i.e.: ${moment().format(pattern)})`;
    }
  }
};

export const dateFormatOptions = () => {
  return settingDates.map((option) => ({
    value: option,
    name: lableForDatePatters(option),
  }));
};
